import {installNetworkGuard} from './network-policy.mjs';

// Keep this entry synchronous and before every captured application script.
installNetworkGuard();
